import { type LetterFileDto } from "../dto/letter-file.dto";
import { sortBy, uniqBy } from "lodash";
import { useAuthStore } from "@pasta/front-auth-v2";
import { ref } from "vue";
import { useClassFactory } from "@pasta/box-v2";
import { useLetterFileStore } from "../stores/letter-file.store";

class ShowSignedNotified {
  public names = ref<string[]>([]);

  public register(letterFile: LetterFileDto) {
    const authStore = useAuthStore();
    const letterFileStore = useLetterFileStore();
    const currentLogin = authStore.currentUser?.login.toLowerCase();
    const uniq = uniqBy(
      [...letterFile.upstream!, letterFile.current, ...letterFile.downstream!, ...letterFile.ccUsers!],
      "mail"
    );
    this.names.value = sortBy(uniq, "name")
      .filter(
        item =>
          item && item?.mail.toLowerCase() !== currentLogin && !letterFileStore.balaWhiteList.includes(item?.mail || "")
      )
      .map(item => item?.name || "");
  }
}

export const [showSignedNotifiedToken, useShowSignedNotified] = useClassFactory(ShowSignedNotified);
